import {
  Button,
  CircularProgress,
  // TableBody,
  // TableCell,
  // TableRow,
  TextField,
  Typography,
} from "@mui/material";
import { FC, useContext, useEffect, useState } from "react";
import CustomChipInput from "./CustomChipInput";
import { useMutation } from "react-query";
import { getTreatmentPlan, postTreatment } from "../../services";
import { useParams } from "react-router-dom";
import usePopup from "../../../hooks/usePopup";
// import LogComonent from "../layouts/LogComonent";
import { PatientManagementContext } from "./PatientManagementPlanProvider";
import { wordBreak } from ".";
import HistoryComponent from "../layouts/HistoryComponent";

const TreatmentPlan: FC = () => {
  const { encounterId } = useParams();
  const { showSnackbar } = usePopup();
  const [health, setHealth] = useState<string[]>([]);
  const [investigation, setInvestigation] = useState<string[]>([]);
  const [medication, setMedication] = useState<string>("");
  const [followUp, setFollowUp] = useState<string>("");
  const { editedField, setEditedField } = useContext(PatientManagementContext);
  const [saved, setSaved] = useState<boolean>();
  const {
    mutate: fetchList,
    isLoading: listLoading,
    data,
  } = useMutation(getTreatmentPlan, {
    onSuccess: (result) => {
      console.log(result);
      if (result.responseIndicator == "success") {
        const { response } = result;
        const healthed = response?.healthEducation
          ? response.healthEducation.split(wordBreak)
          : [];
        const investigationarr = response?.investigation
          ? response.investigation.split(wordBreak)
          : [];
        setHealth(healthed);
        setInvestigation(investigationarr);
        setMedication(response.medication);
        setFollowUp(response.followUp);
      }
    },
  });

  const { mutate: saveTreatment, isLoading: saveLoading } = useMutation(
    postTreatment,
    {
      onSuccess: (result) => {
        if (result.responseIndicator == "success") {
          showSnackbar({
            message: result.responseMessage,
            open: true,
            variant: "success",
            duration: 2000,
          });
          setEditedField(null);
          setSaved(true);
          fetchList(encounterId as string);
        } else {
          showSnackbar({
            message: "Failed !",
            open: true,
            variant: "warning",
            duration: 2000,
          });
        }
      },
      onError: () => {
        showSnackbar({
          message: "Something went wrong !",
          open: true,
          variant: "warning",
          duration: 2000,
        });
      },
    },
  );

  const handleSave = () => {
    let healthEducation = "";
    health.forEach((i, index) => {
      healthEducation += `${i}${index == health.length - 1 ? "" : wordBreak}`;
    });
    let investigations = "";
    investigation.forEach((i, index) => {
      investigations += `${i}${index == investigation.length - 1 ? "" : wordBreak}`;
    });
    saveTreatment({
      companyId: 0,
      id: data?.response?.id || 0,
      encounter: parseInt(encounterId as string),
      IP: null,
      isModified: 0,
      healthEducation,
      followUp,
      investigation: investigations,
      healthEducationName: null,
      medication,
      status: 1,
      visitId: 0,
    });
    console.log(saved, editedField);
    // if(saved){
    //   if(editedField == "treatmentPlan"){
    //     saveTreatment({
    //       companyId: 0,
    //       id: data?.response?.id || 0,
    //       encounter: parseInt(encounterId as string),
    //       IP: null,
    //       isModified: 0,
    //       healthEducation,
    //       followUp,
    //       investigation: investigations,
    //       healthEducationName: null,
    //       medication,
    //       status: 1,
    //       visitId: 0,
    //     });
    //   }else{
    //     showSnackbar({
    //       message: "No new items to add",
    //       open: true,
    //       variant: "warning",
    //       duration: 2000,
    //     });
    //   }
    // }else if(health?.length>0){
    //   saveTreatment({
    //     companyId: 0,
    //     id: data?.response?.id || 0,
    //     encounter: parseInt(encounterId as string),
    //     IP: null,
    //     isModified: 0,
    //     healthEducation,
    //     followUp,
    //     investigation: investigations,
    //     healthEducationName: null,
    //     medication,
    //     status: 1,
    //     visitId: 0,
    //   });
    // }else{
    //   showSnackbar({
    //     message: "No new items to add",
    //     open: true,
    //     variant: "warning",
    //     duration: 2000,
    //   });
    // }
  };

  const handleReset = () => {
    saveTreatment({
      companyId: 0,
      id: data?.response?.id || 0,
      encounter: parseInt(encounterId as string),
      IP: null,
      isModified: 0,
      healthEducation: "",
      followUp: "",
      investigation: "",
      healthEducationName: null,
      medication: "",
      status: 1,
      visitId: 0,
    });
  };

  useEffect(() => {
    fetchList(encounterId as string);
  }, []);
  return (
    <div className="border-2 rounded">
      <div className="p-2 border-b flex justify-between items-center">
        <Typography color="primary" fontWeight={600}>
          Treatment Plan
        </Typography>
        <div>
          {/* <LogComonent title="Treatment Plan" field="treatmentplan" /> */}
          <HistoryComponent logProps={{title:"Treatment Plan",field:"treatmentplan"}} title="Treatment Plan" tableprops={tableprops} />
        </div>
        {/* {logButton} */}
      </div>
      <div className="p-2 grid grid-cols-12 gap-x-2 gap-y-2">
        <div className="col-span-6">
          <CustomChipInput
            placeholder="Health education"
            chips={health}
            setChips={setHealth}
            loading={listLoading}
            component={"treatmentPlan"}
          />
        </div>
        <div className="col-span-6">
          <CustomChipInput
            placeholder="Investigation"
            chips={investigation}
            setChips={setInvestigation}
            loading={listLoading}
            component={"treatmentPlan"}
          />
        </div>
        <div className="col-span-6">
          <TextField
            fullWidth
            label="Medication"
            value={medication}
            onChange={(e) => {
              setMedication(e.target.value);
              setEditedField("treatmentPlan");
            }}
          />
        </div>
        <div className="col-span-6">
          <TextField
            fullWidth
            label="Follow up"
            value={followUp}
            onChange={(e) => {
              setFollowUp(e.target.value);
              setEditedField("treatmentPlan");
            }}
          />
        </div>

        <div className="col-span-full flex gap-2 items-center justify-end">
          <Button
            color="success"
            onClick={handleSave}
            disabled={saveLoading}
            endIcon={saveLoading && <CircularProgress size={18} />}
          >
            save
          </Button>
          <Button color="error" disabled={saveLoading} onClick={handleReset}>
            reset
          </Button>
        </div>
      </div>
    </div>
  );
};

export default TreatmentPlan;
// const headings = [
//   "DATE",
//   "HEALTH EDUCATION",
//   "INVESTIGATION",
//   "MEDICATION",
//   "FOLLOW UP",
//   "MODIFIED BY",
// ];

const tableprops = [
  {
    heading: "Health education",
    key: "healthEducation",
  },
  {
    heading: "Investigation",
    key: "investigation",
  },
  {
    heading: "Medication",
    key: "medication",
  },
  {
    heading: "Follow Up",
    key: "followUp",
  },
];
